module.exports = __webpack_public_path__ + "static/media/banner-mobile.6e023364.jpg";